// extracted by mini-css-extract-plugin
module.exports = {"aside":"ArticleContent_aside__yBSh8","tableOfContents":"ArticleContent_tableOfContents__zbr2Q","content":"ArticleContent_content__gNObJ"};